import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getSubscriptionQueryKey } from "../lib/subscriptionQuery"

export function useDeleteTopupsSetupMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await axios.delete("/billing/checkout/topups")
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getSubscriptionQueryKey() })
    },
  })
}
